import { useQuery } from "@tanstack/react-query";
import useMutationWithInvalidation from "neetocommons/react-utils/useMutationWithInvalidation";

import {
  queryWidgetApiKey,
  fetchWidgetConfiguration,
  updateWidgetConfiguration,
} from "./api";
import { DEFAULT_QUERY_STALE_TIME, QUERY_KEYS } from "./constants";

export const useFetchApiKey = () =>
  useQuery({
    queryKey: [QUERY_KEYS.apiKey],
    queryFn: () => {
      if (
        window.globalProps.railsEnv === "heroku" ||
        !window.globalProps.ssoEnabled
      ) {
        return Promise.resolve({ widgetApiKey: "placeholder-api-key" });
      }

      return queryWidgetApiKey();
    },
    staleTime: DEFAULT_QUERY_STALE_TIME,
  });

export const useFetchConfigurations = () =>
  useQuery({
    queryKey: [QUERY_KEYS.configuration],
    queryFn: fetchWidgetConfiguration,
    staleTime: DEFAULT_QUERY_STALE_TIME,
  });

export const useUpdateConfigurations = (options = {}) =>
  useMutationWithInvalidation(updateWidgetConfiguration, {
    keysToInvalidate: [[QUERY_KEYS.configuration]],
    ...options,
  });
